module.exports = __webpack_public_path__ + "img/Group 4642_copy1.97c46452.png";